import React from "react";

const BoyShape = ({ boyImage }) => {
  return (
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 303 350" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <defs>
        {/* Définition du dégradé */}
        <linearGradient id="boyGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#E26D00" />
          <stop offset="100%" stopColor="#FF543E" />
        </linearGradient>
        
        {/* Définition du clipPath pour l'image */}
        <clipPath id="boyClip">
          <path d="M187.625 5.9582L29.6254 79.4582C15.2261 86.1566 8.6257 103.916 7.12543 111.958C-4.87366 150.458 2.12543 192.458 7.12543 210.958C16.3254 252.958 62.6246 323.958 150.625 342.458L228.125 348.958C291.125 348.958 306.125 290.458 301.125 269.958L286.125 65.4582C286.125 40.958 254.125 -17.5419 187.625 5.9582Z" />
        </clipPath>
      </defs>
      
      {/* Forme avec le dégradé en background */}
      <path 
        d="M187.625 5.9582L29.6254 79.4582C15.2261 86.1566 8.6257 103.916 7.12543 111.958C-4.87366 150.458 2.12543 192.458 7.12543 210.958C16.3254 252.958 62.6246 323.958 150.625 342.458L228.125 348.958C291.125 348.958 306.125 290.458 301.125 269.958L286.125 65.4582C286.125 40.958 254.125 -17.5419 187.625 5.9582Z" 
        fill="url(#boyGradient)" 
        stroke="black"
        strokeWidth="1"
      />
      
      {/* Image boy.png avec clipPath */}
      <image
        href={boyImage}
        x="0"
        y="0"
        width="303"
        height="350"
        clipPath="url(#boyClip)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  );
};

export default BoyShape;